import { render } from "./invest.vue?vue&type=template&id=9658de10&scoped=true"
import script from "./invest.vue?vue&type=script&lang=js"
export * from "./invest.vue?vue&type=script&lang=js"

import "./invest.vue?vue&type=style&index=0&id=9658de10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9658de10"

export default script